export default __webpack_public_path__ + "static/media/android-icon.e2c8938b.svg";